import PropTypes from 'prop-types'
import React, { useEffect, useMemo, useState } from 'react'
import * as Yup from 'yup'

import {
  Form,
  FormikDialog,
  FormikTextField,
  FIELD_REQUIRED,
} from 'src/modules/ui'

import { InputAdornment } from '@material-ui/core'
import { useRecipes } from '../../hooks'
import { useActionRunner } from '../../../../../notification'

const EquipmentTypeModal = ({ editEquipmentType, ...props }) => {
  const { createEquipmentType, updateEquipmentType } = useRecipes()
  const [modalOpen, setModalOpen] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const [doCreateEquipmentType] = useActionRunner(createEquipmentType)
  const [doUpdateEquipmentType] = useActionRunner(updateEquipmentType)

  const initialValues = useMemo(() => {
    return {
      name: '',
      price_per_unit: '',
      usage_per_hour: '',
    }
  }, [])

  useEffect(() => {
    if (editEquipmentType) {
      initialValues.name = editEquipmentType.name
      initialValues.price_per_unit = editEquipmentType.pricePerUnit
      initialValues.usage_per_hour = editEquipmentType.usagePerHour
      setModalOpen(true)
    }
  }, [editEquipmentType, initialValues])

  const handleCloseModal = () => {
    if (!isSubmitting) {
      setModalOpen(false)
    }
  }

  const handleSubmit = async values => {
    setIsSubmitting(true)
    try {
      if (editEquipmentType && editEquipmentType.id) {
        await doUpdateEquipmentType({
          id: editEquipmentType.id,
          body: {
            name: values.name,
            price_per_unit: values.price_per_unit,
            usage_per_hour: values.usage_per_hour,
          },
        })
      } else {
        await doCreateEquipmentType({
          name: values.name,
          price_per_unit: values.price_per_unit,
          usage_per_hour: values.usage_per_hour,
        })
      }
      setModalOpen(false)
    } catch (error) {
      console.log(error)
    }
    setIsSubmitting(false)
  }

  const validationSchema = Yup.object().shape({
    name: Yup.string().required(FIELD_REQUIRED),
    price_per_unit: Yup.number()
      .required(FIELD_REQUIRED)
      .typeError('Must be a number'),
    usage_per_hour: Yup.number()
      .required(FIELD_REQUIRED)
      .typeError('Must be a number'),
  })

  return (
    <FormikDialog
      initialValues={initialValues}
      onSubmit={values => handleSubmit(values)}
      submitText="Add"
      successNotification="Equipment Type Added"
      title="Add Equipment Type"
      validationSchema={validationSchema}
      open={modalOpen}
      onClose={handleCloseModal}
      {...props}
    >
      <Form>
        <FormikTextField
          fullWidth
          label="Equipment Name"
          margin="normal"
          name="name"
          type="text"
        />
        <FormikTextField
          fullWidth
          name="price_per_unit"
          margin="normal"
          type="text"
          placeholder="Price Per Unit"
          InputProps={{
            startAdornment: (
              <InputAdornment style={{ marginTop: '0rem' }} position="start">
                £
              </InputAdornment>
            ),
            endAdornment: <InputAdornment position="end">/unit</InputAdornment>,
          }}
        />
        <FormikTextField
          fullWidth
          name="usage_per_hour"
          margin="normal"
          type="text"
          label="Usage Per Hour"
        />
      </Form>
    </FormikDialog>
  )
}

EquipmentTypeModal.propTypes = {
  selectedEnvironment: PropTypes.number,
  supplier: PropTypes.shape({
    id: PropTypes.number,
    logo: PropTypes.string,
    name: PropTypes.string,
  }),
  subject: PropTypes.string,
  trigger: PropTypes.func,
}

EquipmentTypeModal.defaultProps = {
  environmentId: '',
}

export default EquipmentTypeModal
